import { AttributeEditModeConfig } from '@source-components-react/types';

export const attributeEditModeConfigs: AttributeEditModeConfig[] = [
  {
    name: 'content-text-3-resolutions',
    defaultValues: {},
  },
  {
    name: 'enclosing-tag-3-resolutions',
    heading: 'Enclosing Tag',
    subHeading:
      'HTML tag to enclose the text in (e.g. p, h1, span); see ENCLOSING_TAGS for the allowed values, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'links-3-resolutions',
    heading: 'Links',
    subHeading:
      'Links this text can point at. To link part of the text, wrap those words in {1|linked text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
  {
    name: 'inline-styles-3-resolutions',
    heading: 'Class Names & Styles',
    subHeading:
      'Class names and CSS this text can apply to part of itself, e.g. to give a few words their own colour. To apply an entry, wrap those words in {.1|styled text}, where the number is the position of the entry in this list counting from 1; clearing an entry leaves its position in place so the other numbers keep pointing where they did, for 3 different device resolutions',
    defaultValues: {},
  },
];
